// ---------------------------------------------------------------------------
// PLAN B: Rabatt kommt aus der Discount Function, nicht mehr aus Codes
// ---------------------------------------------------------------------------
// true  = diese Datei setzt KEINE BUNDLE*-Codes mehr. Die Anzeige (Boxen, Fortschritt,
//         Gast-Teaser) bleibt unveraendert — fuer die Kundin sieht alles aus wie bisher,
//         nur der Rabatt entsteht serverseitig.
// false = altes Verhalten mit Rabattcodes.
//
// 🔴 Reihenfolge beim Umschalten: ERST die Function scharfschalten, DANN hier auf true
// und pushen, DANN die neun BUNDLE*-Codes deaktivieren. Andersherum entsteht ein Loch,
// in dem niemand Rabatt bekommt.
//
// Zurueck geht es jederzeit: auf false setzen, pushen, Codes wieder aktivieren.
const BUNDLE_CODES_AUS = true;

const EXCLUDED_BUNDLE_TAGS = ['exclude_bundle', 'kollektion_sonderangebot'];
const _tagCache = {};

const rewards = {
  bronze: [
    { minItems: 3, percent: 5, code: 'BUNDLE5BRONZE' },
    { minItems: 5, percent: 10, code: 'BUNDLE10BRONZE' },
    { minItems: 6, percent: 15, code: 'BUNDLE15BRONZE' }
  ],
  silver: [
    { minItems: 3, percent: 7, code:  'BUNDLE7SILVER' },
    { minItems: 5, percent: 12, code: 'BUNDLE12SILVER' },
    { minItems: 6, percent: 17, code: 'BUNDLE17SILVER' }
  ],
  gold: [
    { minItems: 3, percent: 10, code: 'BUNDLE10GOLD' },
    { minItems: 5, percent: 15, code: 'BUNDLE15GOLD' },
    { minItems: 6, percent: 20, code: 'BUNDLE20GOLD' }
  ]
};


// --- Bundle System enable/disable state management ---
const BUNDLE_LS_KEY = 'bundle_enabled_flag';
// Grace period timestamp to avoid immediate re-disable while re-activating
window.__BUNDLE_REENABLE_UNTIL = window.__BUNDLE_REENABLE_UNTIL || 0;
function getBundleEnabled() {
  try {
    const v = localStorage.getItem(BUNDLE_LS_KEY);
    if (v === null) return true; // default enabled
    return v === '1';
  } catch (_) {
    return true;
  }
}
function setBundleEnabled(enabled) {
  try {
    localStorage.setItem(BUNDLE_LS_KEY, enabled ? '1' : '0');
  } catch (_) {}
  window.__BUNDLE_ENABLED = !!enabled;
}
window.__BUNDLE_ENABLED = getBundleEnabled();
window.__BUNDLE_FORCE_CODE = window.__BUNDLE_FORCE_CODE || null;
window.__BUNDLE_FORCE_UNTIL = window.__BUNDLE_FORCE_UNTIL || 0;

// Legacy codes that should not be treated as "external" discounts
const LEGACY_BUNDLE_CODES = [
  'BUNDLE10BRONZE_APRIL','BUNDLE20BRONZE_APRIL','BUNDLE30BRONZE_APRIL',
  'BUNDLE14SILVER_APRIL','BUNDLE24SILVER_APRIL','BUNDLE34SILVER_APRIL',
  'BUNDLE20GOLD_APRIL','BUNDLE30GOLD_APRIL','BUNDLE40GOLD_APRIL'
];
function getAllBundleCodes() {
  return Object.values(rewards).flat().map(r => r.code).concat(LEGACY_BUNDLE_CODES);
}
function hasNonBundleCodes(cart) {
  // Nur tatsächlich aktive/applicable Codes betrachten
  const activeCodes = (cart.discount_codes || [])
    .filter(dc => dc && (dc.applicable === undefined ? true : !!dc.applicable))
    .map(dc => dc.code);
  const allBundle = new Set(getAllBundleCodes());
  return activeCodes.some(code => !allBundle.has(code));
}

// Entfernt alle Rabattcodes über die Shopify Cart AJAX API
async function clearAllDiscounts() {
  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    });
    // Einige Implementierungen liefern 200 ohne JSON-Body
    try { return await res.json(); } catch (_) { return null; }
  } catch (e) {
    return null;
  }
}

// Setzt die Rabattcodes-Liste gezielt auf genau einen Code
async function applyDiscountDirect(code) {
  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: String(code || '') })
    });
    try { return await res.json(); } catch (_) { return null; }
  } catch (e) {
    return null;
  }
}



function getCurrentTier() {
  const tier = (window.smileVIPTier || '').toLowerCase();
  if (['gold', 'silver', 'bronze'].includes(tier)) return tier;
  return null; // No default tier - bundle system only for members
}


function getCurrentReward(tier, itemCount) {
  const tierRewards = rewards[tier];
  for (let i = tierRewards.length - 1; i >= 0; i--) {
    if (itemCount >= tierRewards[i].minItems) {
      return tierRewards[i];
    }
  }
  return null;
}

let lastAppliedDiscount = null;
// Debug flag for bundle system (disabled by default; set window.BUNDLE_DEBUG=true to enable)
window.BUNDLE_DEBUG = (typeof window !== 'undefined' && typeof window.BUNDLE_DEBUG !== 'undefined') ? window.BUNDLE_DEBUG : false;

function autoApplyBundleDiscount(cart) {
  // 🔴 Uebergangsphase: Ist der neue Bundle-Drawer auf der Seite, rabattiert die
  // Discount Function `bundle-tiers`. Wuerden wir hier zusaetzlich einen BUNDLE*-Code
  // setzen, bekaeme die Kundin beides. Der Drawer setzt das Flag beim Rendern.
  // Faellt weg, sobald die Codes deaktiviert sind (Schritt 8 in docs/BUNDLE-DRAWER-PLAN.md).
  if (window.__DHB_DRAWER_AKTIV || BUNDLE_CODES_AUS) {
    return;
  }
  // Wenn Bundle deaktiviert ist, keine Auto-Logik ausführen
  if (!window.__BUNDLE_ENABLED) {
    return;
  }
  // 1. Alle gültigen Bundle-Codes ermitteln
  const allBundleCodes = getAllBundleCodes();

  // 2. Alle aktuell im Cart gesetzten Rabattcodes holen
  const activeCodes = (cart.discount_codes || []).map(dc => dc.code);

  // 3. Nicht-Bundle-Codes werden NICHT erneut angewendet (vermeidet Update-Schleifen)
  const nonBundleCodes = activeCodes.filter(code => !allBundleCodes.includes(code));
  if (nonBundleCodes.length) {
    if (window.BUNDLE_DEBUG) try { console.log('[BUNDLE] Non-bundle codes present:', nonBundleCodes); } catch (_) {}
  }

  // 4. Den aktuellen gewünschten Bundle-Code ermitteln
  const tier = getCurrentTier();
  const itemCount = getTotalItemCount(cart.items);
  const reward = getCurrentReward(tier, itemCount);
  const bundleCode = reward ? reward.code : null;

  // 6. Bundle-Code setzen, falls vorhanden UND noch nicht angewendet
  if (bundleCode) {
    const isAlreadyApplied = activeCodes.includes(bundleCode);
    if (!isAlreadyApplied) {
      window.SLIDECART_APPLY_DISCOUNT(bundleCode);
      if (window.BUNDLE_DEBUG) try { console.log(`Bundle Rabattcode angewendet: ${bundleCode}`); } catch(_) {}
    } else {
      // Nur loggen wenn sich etwas geändert hat
      if (lastAppliedDiscount !== bundleCode) {
        if (window.BUNDLE_DEBUG) try { console.log(`Bundle Rabattcode bereits angewendet: ${bundleCode}`); } catch(_) {}
        lastAppliedDiscount = bundleCode;
      }
    }
  }
}



function getNextReward(tier, itemCount) {
  const tierRewards = rewards[tier];
  for (let i = 0; i < tierRewards.length; i++) {
    if (itemCount < tierRewards[i].minItems) {
      return tierRewards[i];
    }
  }
  return null;
}

function expandCartItems(cartItems) {
  const filteredItems = cartItems.filter(item => {
    if (item.tags && Array.isArray(item.tags)) {
      return !item.tags.some(tag => EXCLUDED_BUNDLE_TAGS.includes(tag));
    }
    return true;
  });

  const expanded = [];
  filteredItems.forEach(item => {
    for (let i = 0; i < item.quantity; i++) {
      expanded.push(item);
    }
  });
  return expanded;
}

function getTotalItemCount(cartItems) {
  const filteredItems = cartItems.filter(item => {
    if (item.tags && Array.isArray(item.tags)) {
      return !item.tags.some(tag => EXCLUDED_BUNDLE_TAGS.includes(tag));
    }
    return true;
  });

  const count = filteredItems.reduce((sum, item) => sum + item.quantity, 0);
  return count;
}

function getBundleTitle(itemCount, rewardsForTier) {
  let nextReward = null;
  for (let i = 0; i < rewardsForTier.length; i++) {
    if (itemCount < rewardsForTier[i].minItems) {
      nextReward = rewardsForTier[i];
      break;
    }
  }
  if (nextReward) {
    const fehlend = nextReward.minItems - itemCount;
    const produktWort = fehlend === 1 ? 'Produkt' : 'Produkte';
    return `Noch ${fehlend} ${produktWort} für ${nextReward.percent}% Rabatt auf dein Bundle!`;
  } else {
    return `Du bist der Hammer! Du hast alle Rabatte freigeschaltet!`;
  }
}

let slidecartRenderTimeout = null;
let lastRenderTime = 0;
let lastCartState = null;


// --- Delivery estimate rendering ---
function addDays(d, n) {
  const nd = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  nd.setDate(nd.getDate() + n);
  return nd;
}

function isBetweenFri12AndMon12(now) {
  const day = now.getDay(); // 0=So,1=Mo,...,5=Fr,6=Sa
  const hour = now.getHours();
  if (day === 5 && hour >= 12) return true;       // Fr ab 12
  if (day === 6) return true;                     // Sa
  if (day === 0) return true;                     // So
  if (day === 1 && hour < 12) return true;        // Mo bis 12
  return false;
}

function nextWeekday(from, targetDay) {
  const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  let add = (targetDay - d.getDay() + 7) % 7;
  if (add === 0) add = 7;
  return addDays(d, add);
}

function computeDeliveryRange(now) {
  if (isBetweenFri12AndMon12(now)) {
    const start = nextWeekday(now, 2); // Dienstag
    const end = addDays(start, 1);     // Mittwoch
    return { start, end };
  }
  const beforeNoon = now.getHours() < 12;
  const minOffset = beforeNoon ? 1 : 2;
  const maxOffset = beforeNoon ? 2 : 3;
  return { start: addDays(now, minOffset), end: addDays(now, maxOffset) };
}

function formatDateDEShort(d) {
  const wdays = ['So','Mo','Di','Mi','Do','Fr','Sa'];
  const dd = d.getDate();
  const mm = d.getMonth() + 1;
  return `${wdays[d.getDay()]} ${dd}.${mm}`;
}

function renderDeliveryEstimate() {
  try {
    const anchor = document.getElementById('my-slidecart-custom-content');
    if (!anchor) return;
    const existing = document.getElementById('delivery-estimate-wrap');
    const now = new Date();
    let { start, end } = computeDeliveryRange(now);
    // Sonntag nicht zustellen: auf Montag schieben
    const avoidSunday = (d) => (d.getDay() === 0 ? addDays(d, 1) : d);
    start = avoidSunday(start);
    end = avoidSunday(end);
    // Sicherstellen, dass end >= start
    if (end < start) end = addDays(start, 1);
    const text = `Lieferung ca. ${formatDateDEShort(start)} - ${formatDateDEShort(end)}`;

    // Create/update wrapper
    const wrap = existing || document.createElement('div');
    wrap.id = 'delivery-estimate-wrap';
    wrap.className = 'delivery-estimate-wrap';
    wrap.innerHTML = `
      <div class="delivery-estimate">${text}</div>
    `;

    // Insert before the bundle custom content
    if (!existing) {
      anchor.parentNode.insertBefore(wrap, anchor);
    }
  } catch (_) {}
}

window.renderSlidecartBoxes = function () {
  // Auto re-enable: Wenn Bundle deaktiviert war, prüfe ob noch ein externer Code aktiv ist
  if (!window.__BUNDLE_ENABLED) {
    // Schneller Cart-Check um zu sehen ob der externe Code noch da ist
    try {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        if (!hasNonBundleCodes(cart)) {
          setBundleEnabled(true);
          if (window.BUNDLE_DEBUG) try { console.debug('[BUNDLE] Auto re-enabled: no external discount codes present'); } catch (e) {}
          window.renderSlidecartBoxes(); // Nochmal aufrufen, jetzt enabled
        }
      });
    } catch (e) {}
    return;
  }

  const now = Date.now();

  // Throttling: Maximal alle 1000ms ausführen
  if (now - lastRenderTime < 1000) {
    if (window.BUNDLE_DEBUG) try { console.log('[THROTTLED] renderSlidecartBoxes übersprungen - zu häufiger Aufruf'); } catch(_) {}
    return;
  }
  
  const tier = getCurrentTier();

  // Doppelte Calls in kurzer Zeit verhindern
  if (slidecartRenderTimeout) clearTimeout(slidecartRenderTimeout);
  slidecartRenderTimeout = setTimeout(() => {
    lastRenderTime = now;
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Prüfen ob sich der Cart-Status geändert hat
        const cartStateKey = [
          (cart.items || []).map(i => `${i.variant_id}:${i.quantity}`).sort().join('|'),
          (cart.discount_codes || []).map(dc => dc.code).join(',')
        ].join(';');
        if (lastCartState === cartStateKey) {
          if (window.BUNDLE_DEBUG) try { console.log('[SKIP] Cart-Status unverändert, überspringe Verarbeitung'); } catch(_) {}
          return;
        }
        lastCartState = cartStateKey;

        // Check if user is a member (has a tier)
        if (!tier) {
          // Not a member - show teaser with registration link
          const guestItemCount = getTotalItemCount(cart.items || []);
          function tryInjectGuest() {
            const customBox = document.getElementById('my-slidecart-custom-content');
            if (customBox) {
              const savedHint = guestItemCount >= 3
                ? `<div class="bundle-guest-saved">Bei 3+ Artikeln sparst du als Member sofort <strong>bis zu 20%</strong>!</div>`
                : `<div class="bundle-guest-saved">Noch ${3 - guestItemCount} Artikel bis zu deinem ersten Bundle-Rabatt!</div>`;
              customBox.innerHTML = `
                <div class="bundle-guest-teaser">
                  <div class="bundle-guest-text">
                    <strong>Member Bundle-Rabatte</strong><br>
                    ${guestItemCount >= 3 ? 'Spare jetzt <strong style="color:#E87EA1">bis zu 20%</strong>!' : 'Noch ' + (3 - guestItemCount) + ' Artikel f\u00fcr deinen ersten Rabatt!'}
                  </div>
                  <a href="#smile-home" class="bundle-guest-cta">Kostenlos Mitglied werden</a>
                </div>
              `;
              renderDeliveryEstimate();
              return true;
            }
            return false;
          }
          if (!tryInjectGuest()) {
            const obs = new MutationObserver(() => { if (tryInjectGuest()) obs.disconnect(); });
            obs.observe(document.body, { childList: true, subtree: true });
          }
          return;
        }

        // Wenn ein externer (Nicht-Bundle) Rabatt aktiv ist, Bundle-System ggf. deaktivieren (mit Schonfrist)
        if (hasNonBundleCodes(cart)) {
          if (Date.now() >= (window.__BUNDLE_REENABLE_UNTIL || 0)) {
            setBundleEnabled(false);
          } else {
            if (window.BUNDLE_DEBUG) try { console.debug('[BUNDLE] Skip disable: in re-enable grace period'); } catch (e) {}
          }
        } else if (!window.__BUNDLE_ENABLED) {
          // Kein externer Rabattcode mehr aktiv → Bundle automatisch wieder aktivieren
          setBundleEnabled(true);
          if (window.BUNDLE_DEBUG) try { console.debug('[BUNDLE] Auto re-enabled: no external discount codes present'); } catch (e) {}
        }

        // Reduziertes Debug-Logging für Rabattcodes
        if (window.BUNDLE_DEBUG && cart.discount_codes && cart.discount_codes.length > 0) {
          try { console.log(`[DEBUG] ${cart.discount_codes.length} Rabattcode(s) aktiv:`, cart.discount_codes.map(dc => dc.code)); } catch(_) {}
        }

        // Wenn Bundle deaktiviert ist, trotzdem weiter rendern (Overlay liegt später über den Boxen)
        if (false && !window.__BUNDLE_ENABLED) {
          const tryInjectDisabled = () => {
            const customBox = document.getElementById('my-slidecart-custom-content');
            if (customBox) {
              customBox.innerHTML = `
                <div class=\"slidecart-boxes-section is-disabled\">
                  <h2>Bundle-System ist derzeit deaktiviert</h2>
                  <div class=\"boxes-row\"></div>
                  <div class=\"bundle-overlay\">
                    <div class=\"bundle-overlay-content\">
                      <div class=\"bundle-overlay-text\">Du verwendest einen anderen Rabattcode.</div>
                      <button type=\"button\" class=\"bundle-overlay-button\" id=\"bundle-reactivate-btn\">Bundle aktivieren</button>
                      
                    </div>
                  </div>
                </div>
              `;
              const btn = document.getElementById('bundle-reactivate-btn');
              if (btn) {
                btn.addEventListener('click', async function() {
                  // Aktivieren und kurze Schonfrist setzen, damit wir nicht sofort wieder deaktivieren
                  setBundleEnabled(true);
                  window.__BUNDLE_REENABLE_UNTIL = Date.now() + 1500; // 1.5s Grace

                  // SlideCart-Token/Treiber für Re-Apply entfernen
                  try {
                    sessionStorage.removeItem('SLIDECART_CHECKOUT_TOKEN');
                    sessionStorage.removeItem('SLIDECART_CHECKOUT_DATA');
                    window.chCouponCode = '';
                  } catch (_) {}

                  // 1) Passenden Bundle-Code berechnen
                  try {
                    const tierNow = getCurrentTier();
                    const countNow = getTotalItemCount(cart.items || []);
                    const rewardNow = getCurrentReward(tierNow, countNow);
                    if (rewardNow && rewardNow.code) {
                      // Während des erzwungenen Re-Applys Cross-Requests von SlideCart neutralisieren
                      window.__BUNDLE_FORCE_CODE = rewardNow.code;
                      window.__BUNDLE_FORCE_UNTIL = Date.now() + 2500;
                      // 2) Direkt über /cart/update.js nur den Bundle-Code setzen (ersetzt andere Codes)
                      await applyDiscountDirect(rewardNow.code);
                      // 2a) Sofort Server -> SlideCart resync, damit UI den echten Zustand zeigt
                      try {
                        const freshCart = await fetch('/cart.js').then(r => r.json());
                        if (typeof window.SLIDECART_SET_CART === 'function') window.SLIDECART_SET_CART(freshCart);
                        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
                        if (typeof window.SLIDECART_UPDATED === 'function') window.SLIDECART_UPDATED(freshCart);
                      } catch (_) {}
                      // 2b) Leicht verzögert erneut resyncen, falls App-Updates nachlaufen
                      setTimeout(async () => {
                        try {
                          const freshCart2 = await fetch('/cart.js').then(r => r.json());
                          if (typeof window.SLIDECART_SET_CART === 'function') window.SLIDECART_SET_CART(freshCart2);
                          if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
                          if (typeof window.SLIDECART_UPDATED === 'function') window.SLIDECART_UPDATED(freshCart2);
                        } catch (_) {}
                      }, 500);
                      setTimeout(function(){ window.__BUNDLE_FORCE_CODE = null; }, 3000);
                    }
                  } catch (_) {}

                  // 3) Re-Render, nachdem die Änderungen serverseitig gegriffen haben
                  setTimeout(window.renderSlidecartBoxes, 600);
                });
              }
              
              return true;
            }
            return false;
          };

          if (!tryInjectDisabled()) {
            const observer = new MutationObserver(() => {
              if (tryInjectDisabled()) {
                observer.disconnect();
              }
            });
            observer.observe(document.body, { childList: true, subtree: true });
          }

          // Nicht fortfahren, solange deaktiviert
          return;
        }

        // Load product tags for unique handles only (deduplicated, cached)
        const uniqueHandles = Array.from(new Set((cart.items || []).map(i => i.handle).filter(Boolean)));
        const handleFetches = uniqueHandles.map((handle) => {
          if (_tagCache[handle]) return Promise.resolve([handle, _tagCache[handle]]);
          return fetch(`/products/${handle}.js`)
            .then((res) => (res.ok ? res.json() : null))
            .then((productData) => { const tags = (productData && productData.tags) || []; _tagCache[handle] = tags; return [handle, tags]; })
            .catch(() => [handle, []]);
        });

        Promise.all(handleFetches).then((entries) => {
          const tagsByHandle = new Map(entries);
          const cartItemsWithTags = (cart.items || []).map((item) => ({
            ...item,
            tags: tagsByHandle.get(item.handle) || [],
          }));
          function injectCartBoxes(box, cartItems) {
          const tier = getCurrentTier();
          const rewardsForTier = rewards[tier];
          const totalCount = getTotalItemCount(cartItems);

          const titleText = getBundleTitle(totalCount, rewardsForTier);

          const expandedItems = expandCartItems(cartItems);

          // Check for excluded products
          const excludedProducts = cartItems.filter(item => {
            if (item.tags && Array.isArray(item.tags)) {
              return item.tags.some(tag => EXCLUDED_BUNDLE_TAGS.includes(tag));
            }
            return false;
          });

          let boxesHTML = '';
          for (let i = 0; i < 6; i++) {
            const rewardForSlot = rewardsForTier.find(r => r.minItems === (i + 1));
            let percentBadge = '';
            if (rewardForSlot) {
              percentBadge = `<span class="percent-badge">${rewardForSlot.percent}%</span>`;
            }
            if (expandedItems[i]) {
              boxesHTML += `<div class="grey-box">${percentBadge}<img src="${expandedItems[i].image}" alt="${expandedItems[i].title}" class="cart-product-img" /></div>`;
            } else {
              boxesHTML += `<div class="grey-box">${percentBadge}</div>`;
            }
          }

          // Add warning message if excluded products exist
          let warningHTML = '';
          if (excludedProducts.length > 0) {
            const productCount = excludedProducts.reduce((sum, item) => sum + item.quantity, 0);
            const produktWort = productCount === 1 ? 'Produkt ist' : 'Produkte sind';
            warningHTML = `
              <div class="bundle-warning">
                ⚠️ ${productCount} ${produktWort} nicht für das Bundle qualifiziert
              </div>
            `;
          }

          box.innerHTML = `
            <div class="slidecart-boxes-section${window.__BUNDLE_ENABLED ? '' : ' is-disabled'}">
              <h2>${titleText}</h2>
              <div class="boxes-area">
                <div class="boxes-row">
                  ${boxesHTML}
                </div>
                ${warningHTML}
              </div>
            </div>
            ${window.__BUNDLE_ENABLED ? '' : `
            <div class=\"bundle-overlay\">
              <div class=\"bundle-overlay-content\">
                <div class=\"bundle-overlay-text\">Du verwendest einen anderen Rabattcode.</div>
                <button type=\"button\" class=\"bundle-overlay-button\" id=\"bundle-reactivate-btn\">Bundle aktivieren</button>
              </div>
            </div>`}
          `;

          // Render delivery estimate
          renderDeliveryEstimate();

          // Button nur binden, wenn deaktiviert
          if (!window.__BUNDLE_ENABLED) {
            const btn = document.getElementById('bundle-reactivate-btn');
            if (btn) {
              btn.addEventListener('click', async function() {
                // Aktivieren und kurze Schonfrist setzen, damit wir nicht sofort wieder deaktivieren
                setBundleEnabled(true);
                window.__BUNDLE_REENABLE_UNTIL = Date.now() + 1500; // 1.5s Grace

                // SlideCart-Token/Treiber für Re-Apply entfernen
                try {
                  sessionStorage.removeItem('SLIDECART_CHECKOUT_TOKEN');
                  sessionStorage.removeItem('SLIDECART_CHECKOUT_DATA');
                  window.chCouponCode = '';
                } catch (_) {}

                // 1) Passenden Bundle-Code berechnen
                try {
                  const tierNow = getCurrentTier();
                  const countNow = getTotalItemCount(cart.items || []);
                  const rewardNow = getCurrentReward(tierNow, countNow);
                  if (rewardNow && rewardNow.code) {
                    // Während des erzwungenen Re-Applys Cross-Requests von SlideCart neutralisieren
                    window.__BUNDLE_FORCE_CODE = rewardNow.code;
                    window.__BUNDLE_FORCE_UNTIL = Date.now() + 2500;
                    // 2) Direkt über /cart/update.js nur den Bundle-Code setzen (ersetzt andere Codes)
                    await applyDiscountDirect(rewardNow.code);
                    // 2a) Sofort Server -> SlideCart resync, damit UI den echten Zustand zeigt
                    try {
                      const freshCart = await fetch('/cart.js').then(r => r.json());
                      if (typeof window.SLIDECART_SET_CART === 'function') window.SLIDECART_SET_CART(freshCart);
                      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
                      if (typeof window.SLIDECART_UPDATED === 'function') window.SLIDECART_UPDATED(freshCart);
                    } catch (_) {}
                    // 2b) Leicht verzögert erneut resyncen, falls App-Updates nachlaufen
                    setTimeout(async () => {
                      try {
                        const freshCart2 = await fetch('/cart.js').then(r => r.json());
                        if (typeof window.SLIDECART_SET_CART === 'function') window.SLIDECART_SET_CART(freshCart2);
                        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
                        if (typeof window.SLIDECART_UPDATED === 'function') window.SLIDECART_UPDATED(freshCart2);
                      } catch (_) {}
                    }, 500);
                    setTimeout(function(){ window.__BUNDLE_FORCE_CODE = null; }, 3000);
                  }
                } catch (_) {}

                // 3) Re-Render, nachdem die Änderungen serverseitig gegriffen haben
                setTimeout(window.renderSlidecartBoxes, 600);
              });
            }
          }
        }

          function tryInject(cartItems) {
            const customBox = document.getElementById('my-slidecart-custom-content');
            if (customBox) {
              injectCartBoxes(customBox, cartItems);
              return true;
            }
            return false;
          }

          if (!tryInject(cartItemsWithTags)) {
            const observer = new MutationObserver(() => {
              if (tryInject(cartItemsWithTags)) {
                observer.disconnect();
              }
            });
            observer.observe(document.body, { childList: true, subtree: true });
          }

          // Nach Rendering: Bundle Discount prüfen (nur wenn aktiviert)
          if (window.__BUNDLE_ENABLED) {
            autoApplyBundleDiscount(cart);
          }
        });
      });
    slidecartRenderTimeout = null;
  }, 200); // Kurzes Delay, um Ajax-Finish sicher zu sein
};

document.addEventListener('DOMContentLoaded', function () {
  window.renderSlidecartBoxes();
});

// Intercept fetch calls to /cart/add, /cart/update, /cart/change to trigger re-render
(function() {
  const origFetch = window.fetch;
  window.fetch = function(url, opts) {
    const result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|update|change)/.test(url)) {
      result.then(function() {
        setTimeout(window.renderSlidecartBoxes, 300);
      }).catch(function() {});
    }
    return result;
  };
})();
